import React from 'react'

export default function SliderWithSideElement ({ ...props })
{
	return (
		<div className="front-slider-side-wrapper">

			<div className="front-slider-side-wrapper__col">
				{ props.children.slice(0, 1) }
			</div>

			{ props.children.slice(1) }

		</div>
	);
}